import railsFetch from "../railsFetch";
import type { SelectionStatePayload } from "../grids/PaginatedApplicationPrimerGrid";
import type { NestedFilterParams } from "../../domain/grid/resultLoader";
import { bulkSelectionPayload, isRefusal, type BulkRefusal } from "./bulkSelectionPayload";

// GR-3341: blocked dates are organisation settings rows, not event records, so
// they sit outside the BulkOperation pipeline the event grids poll (that
// pipeline is nested under a single event and there is no parent event here).
// This module owns the whole request: one DELETE, one answer back.
//
// GR-3342 rework: the selection shape and the refusal guard moved to
// bulkSelectionPayload, shared with the events archive, so the two bulk
// actions cannot drift apart on what they put on the wire.

export interface BulkDeleteReport {
  deleted: number;
}

export type BulkDeleteRefusal = BulkRefusal;

export type BulkDeleteResult = BulkDeleteReport | BulkDeleteRefusal;

export { isRefusal };

const GENERIC_ERROR = "Could not remove the selected blocked dates. Please try again.";

export const bulkDeleteBlockedDates = async (
  url: string,
  selection: SelectionStatePayload,
  filterParams?: NestedFilterParams
): Promise<BulkDeleteResult> => {
  try {
    const response = await railsFetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(bulkSelectionPayload(selection, filterParams)),
    });

    const body = await response.json().catch(() => ({}));
    if (response.ok) return body as BulkDeleteReport;

    return { errors: (body as BulkDeleteRefusal).errors ?? [GENERIC_ERROR] };
  } catch (error) {
    // A transport failure must still reach the operator: they ticked rows and
    // pressed Delete, and silence reads as "it worked".
    console.error("[bulkDeleteBlockedDates] Error:", error);
    return { errors: [GENERIC_ERROR] };
  }
};
